module.exports = __webpack_public_path__ + "417104990dbbba92a4868a6a94642488.svg";